import { TranslatableEnum } from "@rumble-it/common-lib/types/models/TranslatableEnum.interface";

export const formatTranslatableEnum = (
  value: string | TranslatableEnum | undefined | null,
): string | null => {
  if (value == null) {
    return null;
  }

  return typeof value === "string" ? value : (value.label ?? value.value);
};

export const formatTranslatableEnumList = (
  values: Array<string | TranslatableEnum> | undefined,
): string | null => {
  if (!values?.length) {
    return null;
  }

  return values
    .map((value) => formatTranslatableEnum(value))
    .filter((value): value is string => value !== null)
    .join(", ");
};
